import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute, RootRedirect } from './components/auth/ProtectedRoute';
import { Login } from './components/auth/Login';
import { Layout } from './components/common/Layout';
import { Dashboard } from './components/dashboard/Dashboard';
import { ProductList } from './components/products/ProductList';
import { Sales } from './components/sales/Sales';
import { Analysis } from './components/analysis/Analysis';
import { PriceChangeAndAlert } from './components/pricechange/PriceChangeAndAlert';
import { Logs } from './components/logs/Logs';
import { AdminLayout } from './components/admin/AdminLayout';
import { AppMetrics } from './components/admin/AppMetrics';
import { ROUTES } from './utils/constants';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Route - giriş yapılmışsa dashboard'a yönlendirir */}
          <Route path={ROUTES.LOGIN} element={<Login />} />
          
          {/* Ana sayfa: giriş yapılmışsa dashboard, değilse login */}
          <Route path="/" element={<RootRedirect />} />
          
          {/* Protected Routes */}
          <Route
            path={ROUTES.DASHBOARD}
            element={
              <ProtectedRoute>
                <Layout title="Ana Sayfa"><Dashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRODUCTS}
            element={
              <ProtectedRoute>
                <Layout title="Ürün Yonetim Ekrani"><ProductList /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.SALES}
            element={
              <ProtectedRoute>
                <Layout title="Satış Yonetim Ekrani"><Sales /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ANALYSIS}
            element={
              <ProtectedRoute>
                <Layout title="Analiz ve Satış Geçmişi"><Analysis /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.PRICE_CHANGE_AND_ALERT}
            element={
              <ProtectedRoute>
                <Layout title="Toplu Güncelleme"><PriceChangeAndAlert /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path={ROUTES.ADMIN}
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="logs" replace />} />
            <Route path="logs" element={<Logs />} />
            <Route path="metrics" element={<AppMetrics />} />
          </Route>
          <Route path={ROUTES.LOGS} element={<Navigate to={ROUTES.ADMIN_LOGS} replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
